/**
 * Keeps product handle "chocolate-protection-package" in cart whenever other
 * items exist; removes it when the cart has no other products. Cart UI hides
 * remove/quantity for that line (see cart-items.liquid).
 */
(function () {
  const HANDLE = 'chocolate-protection-package';

  let protectionVariantId = null;
  let syncing = false;

  function productJsonUrl() {
    const root = (window.theme.routes.root_url || '').replace(/\/$/, '');
    return `${root}/products/${HANDLE}.js`;
  }

  function jsonHeaders() {
    return {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    };
  }

  async function fetchProtectionVariantId() {
    if (protectionVariantId) return protectionVariantId;
    try {
      const res = await fetch(productJsonUrl());
      if (!res.ok) return null;
      const product = await res.json();
      const v =
        product.variants.find(function (x) {
          return x.available;
        }) || product.variants[0];
      protectionVariantId = v ? v.id : null;
      return protectionVariantId;
    } catch (e) {
      console.error('[cart-protection-package]', e);
      return null;
    }
  }

  async function syncCartProtection() {
    if (syncing) return;
    const vid = await fetchProtectionVariantId();
    if (!vid) return;

    syncing = true;
    try {
      const cartRes = await fetch(window.theme.routes.cart_url + '.js');
      if (!cartRes.ok) return;
      const cart = await cartRes.json();

      const protectionLines = cart.items.filter(function (i) {
        return i.variant_id === vid;
      });
      const otherItems = cart.items.filter(function (i) {
        return i.variant_id !== vid;
      });
      const hasOtherItems = otherItems.some(function (i) {
        return i.quantity > 0;
      });

      let needsSectionRefresh = false;

      if (hasOtherItems) {
        if (protectionLines.length === 0) {
          await fetch(window.theme.routes.cart_add_url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: jsonHeaders(),
            body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }),
          });
          needsSectionRefresh = true;
        } else {
          for (let i = 0; i < protectionLines.length; i++) {
            const line = protectionLines[i];
            const targetQty = i === 0 ? 1 : 0;
            if (line.quantity !== targetQty) {
              await fetch(window.theme.routes.cart_change_url, {
                method: 'POST',
                credentials: 'same-origin',
                headers: jsonHeaders(),
                body: JSON.stringify({
                  id: line.key,
                  quantity: targetQty,
                }),
              });
              needsSectionRefresh = true;
            }
          }
        }
      } else {
        for (let j = 0; j < protectionLines.length; j++) {
          const line = protectionLines[j];
          if (line.quantity > 0) {
            await fetch(window.theme.routes.cart_change_url, {
              method: 'POST',
              credentials: 'same-origin',
              headers: jsonHeaders(),
              body: JSON.stringify({
                id: line.key,
                quantity: 0,
              }),
            });
            needsSectionRefresh = true;
          }
        }
      }

      if (needsSectionRefresh) {
        document.dispatchEvent(new CustomEvent('theme:update:cart'));
      }
    } finally {
      syncing = false;
    }
  }

  window.switchOnDOMContentLoaded(function () {
    syncCartProtection();
  });

  document.addEventListener('theme:product:add', function () {
    syncCartProtection();
  });

  document.addEventListener('theme:line-item:change', function () {
    syncCartProtection();
  });
})();
